<template>
  <div :class="classObj" class="app-wrapper">
    <Topbar/>
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <sidebar class="sidebar-container" v-if="!booNoSidebar"/>
    <div class="main-container">
      <div :class="fixedHeader ? 'fixed-header' : 'unfixed-header'">
        <tags-view :exData="{hideHamburger: !!booNoSidebar}" v-if="needTagsView"/>
        <navbar/>
      </div>
      <app-main/>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, TagsView, AppMain, Topbar } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    TagsView,
    AppMain,
    Topbar
  },
  data() {
    return {
      booNoSidebar: false
    }
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    needTagsView() {
      return this.$store.state.settings.tagsView
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
        // hasSidebar: !this.booNoSidebar,
        noSidebar: this.booNoSidebar
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {withoutAnimation: false})
    }
  },
  watch: {
    $route: {
      handler(newValue) {
        this.booNoSidebar = newValue.meta.noSidebar
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.fixed-header {
  position: fixed;
  left: $sideBarWidth;
  top: $topBarHeight;
  right: 0;
  z-index: 2001;
}

.unfixed-header {
  padding-top: $topBarHeight;
}

.hideSidebar .fixed-header {
  left: 54px;
}

.mobile .fixed-header {
  left: 0;
}

.noSidebar .fixed-header {
  left: 0;
}

.noSidebar .main-container {
  margin-left: 0 !important;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
